import servicesData from '../../data/servicesData';

const servicesTwoData = servicesData.map(service => ({
    id: service.id,
    slug: service.slug,
    thumbnail: service.thumbnail,
    heading: service.title,
    text: service.shortDescription,
}));

export default servicesTwoData;
